import { render, staticRenderFns } from "./HongKongMinuteChart.vue?vue&type=template&id=20ec56bd&scoped=true"
import script from "./HongKongMinuteChart.vue?vue&type=script&lang=js"
export * from "./HongKongMinuteChart.vue?vue&type=script&lang=js"
import style0 from "./HongKongMinuteChart.vue?vue&type=style&index=0&id=20ec56bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec56bd",
  null
  
)

export default component.exports